import React from "react";
import {
  BackgroundContainer,
  StyledContainer,
  SectionName,
  SectionTitle,
  SectionDescription,
} from "../../Home.styles";
import {
  GridWrapper,
  Item,
  ItemTitle,
  Circle,
  Description,
  Wrapper,
  ActiveInfo,
  StyledLink
} from "./Campaign.styles";

export function Campaign() {
  return (
    <BackgroundContainer>
      <StyledContainer>
        <SectionName center={true}>your campaign</SectionName>
        <SectionTitle center={true}>
          Benefits of your Ads in DoveMed ecosystem
        </SectionTitle>
        <GridWrapper>
          <Item>
            <div>
              <ItemTitle margin={true}>Article Pages</ItemTitle>
              <Wrapper>
                <Circle></Circle>
                <Description>World Class content</Description>
              </Wrapper>
              <Wrapper>
                <Circle></Circle>
                <Description>Wide topic range</Description>
              </Wrapper>
              <Wrapper>
                <Circle></Circle>
                <Description>Approved by doctors</Description>
              </Wrapper>
            </div>
            <StyledLink to={`${process.env.REACT_APP_INTERNAL_URL}benefits`}>View all benefits</StyledLink>
          </Item>
          <Item>
            <div>
              <ActiveInfo>Coming soon...</ActiveInfo>
              <ItemTitle>Physician Profiles</ItemTitle>
              <Wrapper>
                <Circle></Circle>
                <Description>Reach 1.2 milion physicians</Description>
              </Wrapper>
              <Wrapper>
                <Circle></Circle>
                <Description>228 medical specialties</Description>
              </Wrapper>
              <Wrapper>
                <Circle></Circle>
                <Description>Target by locations</Description>
              </Wrapper>
            </div>
            <StyledLink disabled to={`${process.env.REACT_APP_INTERNAL_URL}benefits`}>View all benefits</StyledLink>
          </Item>
          <Item>
            <div>
              <ActiveInfo>Coming soon...</ActiveInfo>
              <ItemTitle>Ask a Doctor</ItemTitle>
              <Wrapper>
                <Circle></Circle>
                <Description>Over 10,000 question pages </Description>
              </Wrapper>
              <Wrapper>
                <Circle></Circle>
                <Description>Answers by qualified physicians</Description>
              </Wrapper>
              <Wrapper>
                <Circle></Circle>
                <Description>Reach wide audience</Description>
              </Wrapper>
            </div>
            <StyledLink disabled to={`${process.env.REACT_APP_INTERNAL_URL}benefits`}>View all benefits</StyledLink>
          </Item>
          <Item>
            <div>
              <ActiveInfo>Coming soon...</ActiveInfo>
              <ItemTitle>MyCircles</ItemTitle>
              <Wrapper>
                <Circle></Circle>
                <Description>Growing community forum</Description>
              </Wrapper>
              <Wrapper>
                <Circle></Circle>
                <Description>Common chronic conditions</Description>
              </Wrapper>
              <Wrapper>
                <Circle></Circle>
                <Description>Reach specific audience</Description>
              </Wrapper>
            </div>
            <StyledLink disabled to={`${process.env.REACT_APP_INTERNAL_URL}benefits`}>View all benefits</StyledLink>
          </Item>
        </GridWrapper>
        <SectionDescription center={true}>and many other...</SectionDescription>
      </StyledContainer>
    </BackgroundContainer>
  );
}
